import { hasEmMarket } from '@/creditflowresearch/domain/Market/selectors/hasEmMarket';

const CORPORATE_ONLY_KEYS = ['includedRegionIds'] as const;
const NON_CORPORATE_KEYS = ['includedMarketIds', 'includedSegmentIds'] as const;
const EM_OMITTED_KEYS = ['includedProductIds'] as const;

const omitKeys = <T extends Record<string, any>>(obj: T, keys: readonly string[]): T =>
  Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key))) as T;

export const adaptFilters = <T extends Record<string, any>>(filters: T, query: Record<string, any>): T => {
  const isCorporate = !!(query.markets || query.segments);

  if (!isCorporate) return omitKeys(filters, NON_CORPORATE_KEYS);
  if (hasEmMarket(query)) return omitKeys(filters, EM_OMITTED_KEYS);

  return omitKeys(filters, CORPORATE_ONLY_KEYS);
};
